(function(angular, schoolwork12) {
	'use strict';
	
	schoolwork12.app.fulfillmentApproval = {
        name: 'schoolwork12.fulfillmentApproval',
        controllers: {
            fulfillmentApproval : 'fulfillmentApprovalCtrl'
        },
        routes: {
            fulfillmentApproval: '/computer-fulfillment'
        },
        templates : {
            fulfillmentApproval: 'fulfillmentApproval/html/fulfillmentSearchAndApprove.html',
            fulfillmentApprovalModal: 'fulfillmentApproval/html/fulfillmentApprovalModal.html',
        },
        services: {                  
        },
        editMessages:{
          editSuccess: "Highlighted school in the search results, below, have been edited during the current search.",          
          fulfillmentSuccessMesg: "Highlighted students in the search results, below, have been edited during the current search.",
          recalculateSuccess: "The highlighted school(s) below have been recalculated."
        },
        errorMessages: {            
            studentIdNumeric: "Only numeric values are valid for Student IDs. Please correct your search criteria in order to proceed.",
            studentIds500: "You have entered more than 500 Student IDs as part of your search criteria. Please limit your search criteria in order to proceed.",
            parentsDeclinedInSearch:"Computer shipment cannot be approved because the family has declined the computer. Please update the computer choice prior to approving the computer shipment",
            approvedStudentsInSearch:"Please verify the request. You can't deny already approved students.",
            cannotOverrideStudentsInSearch:"Please verify the request. One of the selected students is status 'N/A - Cannot Be Overridden'. Please deselect this student(s) in order to proceed.",
            approveApprovedStudentsInSearch:"Please verify the request. Request already has approved students.",
            denyDeniedStudentsInSearch:"Please verify the request. Request already has denied students.",
        },
        endpoints: {
            getEligibleStudentList : schoolwork12.app.endpoint.concat('/fulfillmentApproval/search'),
            saveEligibleStudentList : schoolwork12.app.endpoint.concat('/fulfillmentApproval/save'),
        }
	};
	
	angular.module(schoolwork12.app.fulfillmentApproval.name,['ui.grid','ui.grid.resizeColumns','ui.grid.pagination','ui.grid.selection'
                                                              ,'ui.grid.exporter','ngAnimate','ui.bootstrap'])
    .config([
        '$animateProvider', function($animateProvider) {
            $animateProvider.classNameFilter(/^((?!(ui-grid-menu)).)*$/);
        }
    ]);
     
}(angular, schoolwork12));